import { formatPhoneNumber } from "@/helpers/phone-helpers";
import IUser from "@/interfaces/user.interface";
import { UserStatus } from "@/types/user.types";

type UseUserDataReturn = Partial<IUser> & { isActive: boolean; isEmailVerified: boolean };
type UseUserDataProps = { user: IUser | null };

function useUserData({ user }: UseUserDataProps): UseUserDataReturn {
  const phone1 = formatPhoneNumber(user?.phone1 || "");
  const phone2 = formatPhoneNumber(user?.phone2 || "");
  const isActive = user?.status === UserStatus.Active;
  const isEmailVerified = user?.status !== UserStatus.WaitingForEmailConfirmation;
  return { ...user, phone1, phone2, isActive, isEmailVerified };
}

export default useUserData;
